import PayPalCommerce from './paypal-commerce';
import PayPalCommerceEditModal from './edit-modal';
import PayPalCommerceOnboardingModal from './onboarding-modal';

export default PayPalCommerce;
export { PayPalCommerceEditModal, PayPalCommerceOnboardingModal };
